export const mapIotCallingCampaignToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

export const iotCallingCampaignColumns = [
  { key: "campaignId", label: "Campaign Id", align: "center" },
  { key: "campaignName", label: "Campaign Name", align: "center" },
];
